// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "@firebase/database";
import { getFunctions, httpsCallable } from "@firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyArYX2OdfhdjD-bJRX-b8PjLWRZkZ6U5Tw",
    authDomain: "nutrition-calculator-18ab7.firebaseapp.com",
    databaseURL: "https://nutrition-calculator-18ab7-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "nutrition-calculator-18ab7",
    storageBucket: "nutrition-calculator-18ab7.appspot.com",
    messagingSenderId: "578477280425",
    appId: "1:578477280425:web:b90bc983a45d6515912db8",
    measurementId: "G-9EB3L3YTS3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getDatabase(app);
export const fbFunctions = getFunctions(app);